import "./ContractFieldsView.css";
import { useContract, useSchema } from "../ContractContext";
import { ReactNode } from "react";

export interface Field {
  name: string;
  format?: (value: any) => ReactNode;
}

export interface ContractFieldsViewProps {
  section: string;
  fields: Field[];
}

export default function ContractFieldsView({
  section,
  fields,
}: ContractFieldsViewProps) {
  const contract = useContract();
  const schema = useSchema();

  const group = (contract as any)[section] || {};

  return (
    <table className="ContractFieldsView">
      <tbody>
        {fields.map(({ name, format }) => (
          <tr key={name}>
            <th>{schema.getFieldLabel(section, name)}</th>
            <td>
              {format ? format((group as any)[name]) : (group as any)[name]}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
